module.exports = __webpack_public_path__ + "static/media/wine.62cc310b.png";